import { Check, Crown } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal, ChapterTag } from "./Reveal";

export default function Packages() {
  const { t, lang } = useLang();
  return (
    <section id="packages" data-testid="packages-section" className="max-w-7xl mx-auto px-6 lg:px-10 py-24 md:py-32">
      <Reveal>
        <ChapterTag num="04" label={t("ch_packages")} />
        <h2 className="font-display font-extrabold text-3xl md:text-4xl lg:text-5xl tracking-tight">{t("packages_title")}</h2>
        <p className="mt-4 text-white/60 text-base md:text-lg max-w-2xl leading-relaxed">{t("packages_sub")}</p>
      </Reveal>

      <div className="mt-14 grid lg:grid-cols-3 gap-8 items-stretch">
        {t("packages").map((p, i) => {
          const featured = i === 1;
          const card = (
            <div
              data-testid={`package-card-${i}`}
              className={`h-full rounded-3xl p-8 flex flex-col transition-transform duration-300 hover:-translate-y-2 ${
                featured ? "bg-navy-700/90 backdrop-blur-xl" : "glass"
              }`}
            >
              {featured && (
                <span className="self-start inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-gold text-navy-900 text-xs font-bold mb-4" data-testid="package-featured-badge">
                  <Crown size={12} />
                  {t("most_popular")}
                </span>
              )}
              <h3 className="font-display font-extrabold text-2xl">{p.name}</h3>
              <p className="mt-1 text-sm text-white/50">{p.target}</p>
              <div className="mt-6 flex items-end gap-2.5">
                <span className={`font-display text-5xl font-black leading-none ${featured ? "gold-text" : "text-white"}`} data-testid={`package-price-${i}`}>{p.price}</span>
                <img
                  src="/sar-symbol.png"
                  alt={lang === "ar" ? "ريال سعودي" : "Saudi Riyal"}
                  data-testid={`sar-icon-${i}`}
                  className="h-7 md:h-8 w-auto object-contain mb-1.5 opacity-90"
                />
                <span className="text-white/50 text-sm mb-1.5">{t("per_year")}</span>
              </div>
              <div className="my-6 h-px bg-white/10" />
              <ul className="space-y-3 flex-1">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm text-white/75">
                    <Check size={16} className="text-gold shrink-0 mt-0.5" />
                    {f}
                  </li>
                ))}
              </ul>
              <a
                href="#contact"
                data-testid={`package-cta-${i}`}
                className={`mt-8 inline-flex justify-center px-6 py-3.5 rounded-full font-bold text-sm transition-colors duration-300 ${
                  featured ? "bg-gold text-navy-900 hover:bg-gold-light" : "border border-gold/40 text-gold hover:bg-gold/10"
                }`}
              >
                {t("choose_package")}
              </a>
            </div>
          );
          return (
            <Reveal key={p.name} delay={i * 0.12}>
              {featured ? (
                <div className="h-full rounded-3xl p-[1.5px] bg-gradient-to-b from-gold-light via-gold/30 to-gold shadow-2xl shadow-gold/10 lg:-translate-y-4">{card}</div>
              ) : card}
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
